import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icons as I } from '../pack-icons';

/**
 * AttentionPanel — list of items needing user action.
 * items: [{ kind:'warn'|'info'|'danger', title, sub, action, onAction? }]
 * Pass allClear=true (or empty items) to show "All clear" empty state.
 * researchHint: optional { title, sub, action, onAction } — a soft nudge shown
 *   under the all-clear state (the parent decides whether to pass it).
 */
export default function AttentionPanel({ items, allClear, researchHint }) {
  const { t } = useTranslation();
  const empty = allClear || !items?.length;
  if (empty) {
    return (
      <section className="card attn-panel attn-clear">
        <div className="attn-clear-row">
          <span className="attn-clear-ico">
            <I.check size={16} />
          </span>
          <div className="attn-clear-text">
            <h3>{t('attentionPanel.allClear')}</h3>
            <p>{t('attentionPanel.allClearSub')}</p>
          </div>
        </div>
        {researchHint && (
          <button type="button" className="attn-clear-hint" onClick={researchHint.onAction}>
            <span className="attn-clear-hint-ic"><I.target size={15} /></span>
            <span className="attn-clear-hint-text">
              <span className="attn-clear-hint-title">{researchHint.title}</span>
              <span className="attn-clear-hint-sub">{researchHint.sub}</span>
            </span>
            <span className="attn-clear-hint-cta">{researchHint.action} <I.arrowRight size={11} /></span>
          </button>
        )}
      </section>
    );
  }
  return (
    <section className="card attn-panel">
      <div className="attn-head">
        <div>
          <div className="eyebrow"><span>{t('attentionPanel.eyebrow')}</span></div>
          <h3>
            {t('attentionPanel.heading', { count: items.length, plural: items.length === 1 ? '' : 's' })}
          </h3>
        </div>
      </div>
      <div className="attn-list">
        {items.map((it, i) => (
          <div key={i} className={`attn-item attn-${it.kind}`}>
            <span className="attn-ico">
              {it.kind === 'warn' && <I.alert size={14} />}
              {it.kind === 'info' && <I.info size={14} />}
              {it.kind === 'danger' && <I.alert size={14} />}
            </span>
            <div className="attn-text">
              <div className="attn-title">{it.title}</div>
              <div className="attn-sub">{it.sub}</div>
            </div>
            {it.action && (
              <button className="btn btn-ghost btn-sm" onClick={it.onAction} type="button">
                {it.action} <I.arrowRight size={11} />
              </button>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
